module.exports = __webpack_public_path__ + "static/media/WaitingForBoConfirmation.ff91032f.svg";